import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IZendeskRepository } from '../../repositories/interfaces/iZendeskRepository';
import IZendeskForm from '../../entities/iZendeskForm';

export interface IZendeskSubmitFormUseCase {
    execute(payload: IZendeskForm, credentials: string): Promise<any>;
}

export class SubmitFormUseCase implements IZendeskSubmitFormUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get zendeskRepo(): IZendeskRepository {
        return container.resolve<IZendeskRepository>(DI.REPOSITORIES.IZenDeskRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(payload: IZendeskForm, credentials: string): Promise<any> {
        return await this.zendeskRepo.submitForm(payload, credentials);
    }
}
